import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from '../../mui-overrides/Textfield';

interface Props {
  disabled?: boolean;
}

export const YieldFieldNameTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <DefaultFastTextField
      disabled={disabled}
      type="text"
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.yieldFieldname')}
      fieldName="investmentDetails.yieldFieldname"
      formik={formik}
    />
  );
};
